// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/body","rootFixed":"body-m__rootFixed__2K95C"};